import React from "react";

// components

// import CardSettings from "components/Cards/CardSettings.js";
import CardProfile from "components/Cards/CardProfile.js";
import CardCategorys from "components/Cards/CardCategorys";
import CardUnits from "components/Cards/CardUnits";
import CardProductGroup from "components/Cards/CardProductGroup";
import HeaderStats from "components/Headers/HeaderStats";
import { useSelector } from "react-redux";

export default function Settings() {
  const { user } = useSelector(state => state.user)
  if (user.role == 2) {
    window.location.href = "/order";
  }
  return (
    <>
    <HeaderStats page={"Settings"} />
      <div className="flex flex-wrap">
        <div className="w-full px-4 ">
          <CardCategorys />
        </div>
        <div className="w-full px-4 ">
          <CardUnits />
        </div>
        <div className="w-full px-4 ">
          <CardProductGroup />
        </div>
     
        {/* <div className="w-full px-4 lg:w-4/12">
          <CardProfile />
        </div>
        <div className="w-full px-4 lg:w-4/12">
          <CardProfile />
        </div> */}
      </div>
    </>
  );
}
